.root {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  inline-size: 100%;
  max-inline-size: var(--field-max);
}

.header {
  display: flex;
  gap: var(--space-3);
  align-items: baseline;
  justify-content: space-between;
  font-size: var(--text-sm);
}

.label {
  color: var(--color-text-muted);
  font-weight: var(--weight-medium);
}

.value {
  color: var(--color-text);
  font-variant-numeric: var(--numeric);
  white-space: nowrap;
}

.control {
  display: flex;
  align-items: center;
  block-size: var(--control-sm);
  padding-inline: var(--space-2);
  touch-action: none;
}

/* Base UI positions each thumb on the track itself. */
.track {
  position: relative;
  inline-size: 100%;
  block-size: var(--space-1);
  border-radius: var(--radius-full);
  background: var(--color-border-strong);
}

.indicator {
  block-size: 100%;
  border-radius: var(--radius-full);
  background: var(--color-accent);
}

.thumb {
  inline-size: var(--space-4);
  block-size: var(--space-4);
  border: var(--border-width) solid var(--color-border-strong);
  border-radius: var(--radius-full);
  background: var(--color-surface-raised);
  cursor: grab;
}

.thumb[data-dragging] {
  cursor: grabbing;
}

.thumb:has(:focus-visible) {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

.thumb[data-disabled] {
  cursor: not-allowed;
  opacity: 0.6;
}
